export default __webpack_public_path__ + "static/media/BebasNeue-Regular.87ff20ee.woff2";